var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"footer-hide":"","width":380},model:{value:(_vm.visibility),callback:function ($$v) {_vm.visibility=$$v},expression:"visibility"}},[_c('div',{staticClass:"modal-header",attrs:{"slot":"header"},slot:"header"},[_vm._v("操作验证")]),_c('div',{staticClass:"content"},[_c('div',{attrs:{"id":"captcha-box"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }